import { createContext, useContext } from "react";

const AdminAuthContext = createContext({ role: null, username: null, portalUrl: null });

export const useAdminRole = () => useContext(AdminAuthContext);

export default AdminAuthContext;
